// MODUS open multi-tool brand mark (self-hosted line-art asset).
// onDark (default true) => white icon for dark surfaces; false => indigo icon for light surfaces.
export default function MultiToolMark({ size = 28, className = "", onDark = true }) {
  return (
    <img
      src={onDark ? "/modus-mark-white.png" : "/modus-mark-indigo.png"}
      alt="MODUS"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`object-contain select-none ${className}`}
      draggable={false}
      aria-hidden="true"
    />
  );
}
